<template>
  <div
    v-if="$$FormData.slicer_type === 'line'"
    class="assist-slicer2 line"
    :style="{
      padding: `0 ${$$FormData.slicer_padding}px`,
      backgroundColor: $$FormData.background_color,
    }"
  >
    <div :style="{ borderTop: `1px ${$$FormData.slicer_style} ${$$FormData.slicer_color}` }" class="assist-slicer__hr" />
  </div>
  <div
    v-else
    class="assist-slicer2"
    :style="{
      backgroundColor: $$FormData.background_color,
    }"
  >
    <!-- height: $$FormData.blank_height + 'px', -->
    <div class="swiper-pc2">
      <div
        v-if="show_swiper"
        class="swiper-pc__swiper"
        :style="{
          height: $$FormData.swiper_height + 'px',
          paddingLeft: $$FormData.page_edge + 'px',
          paddingRight: $$FormData.page_edge + 'px',
          '--dot-color': $$FormData.pagination_color,
          '--dot-color-active': $$FormData.pagination_active_color,
        }"
      >
        <div v-if="$$FormData.imageList.length" v-swiper="swiperOptions">
          <div class="swiper-wrapper">
            <div v-for="(item, index) in imgList" :key="index" class="swiper-slide">
              <a :href="$$GetLinkValue(item.link)" class="swiper-pc__item" :style="{ height: $$FormData.swiper_height + 'px' }" target="_self">
                <div
                  class="swiper-pc__image"
                  :style="{
                    backgroundImage: `url(${item.image.src})`,
                    backgroundSize: $$FormData.image_fill,
                    height: $$FormData.swiper_height + 'px',
                  }"
                />
              </a>
            </div>
          </div>
        </div>

        <div v-else class="swiper-pc__empty">
          请添加图片...
        </div>
      </div>
    </div>

    <div v-if="$$FormData.diytclose">
      <div class="zyz-diytp-1">
        <div class="diy-img">
          <!-- <span>{{ $$FormData.diyimg1t }}</span> -->
          <img :src="$$FormData.diyimg1" />
        </div>
        <div class="diy-img diy-img-2 ">
          <!-- <span>{{ $$FormData.diyimg1t }}</span> -->
          <img :src="$$FormData.diyimg2" />
        </div>
        <div class="diy-img">
          <!-- <span>{{ $$FormData.diyimg1t }}</span> -->
          <img :src="$$FormData.diyimg3" />
        </div>
      </div>

      <div class="zyz-diytp-2">
        <div class="diy-t">
          <div class="zyzt1">{{ $$FormData.diyt1 }}</div>
          <div class="zyzt2">
            <img :src="$$FormData.diyimgta1" />
            <img :src="$$FormData.diyimgta2" />
            <img :src="$$FormData.diyimgta3" />
            <img :src="$$FormData.diyimgta4" />
            <img :src="$$FormData.diyimgta5" />
            <img :src="$$FormData.diyimgta6" />
          </div>
        </div>
        <div class="diy-t">
          <div class="zyzt1">{{ $$FormData.diyt2 }}</div>
          <div class="zyzt2">
            <img :src="$$FormData.diyimgtb1" />
            <img :src="$$FormData.diyimgtb2" />
            <img :src="$$FormData.diyimgtb3" />
            <img :src="$$FormData.diyimgtb4" />
            <img :src="$$FormData.diyimgtb5" />
            <img :src="$$FormData.diyimgtb6" />
          </div>
        </div>
        <div class="diy-t">
          <div class="zyzt1">{{ $$FormData.diyt3 }}</div>
          <div class="zyzt2">
            <img :src="$$FormData.diyimgtc1" />
            <img :src="$$FormData.diyimgtc2" />
            <img :src="$$FormData.diyimgtc3" />
            <img :src="$$FormData.diyimgtc4" />
            <img :src="$$FormData.diyimgtc5" />
            <img :src="$$FormData.diyimgtc6" />
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="zyz-diytp-1-1">
        <div class="diy-img">
          <!-- <span>{{ $$FormData.diyimg1t }}</span> -->
          <img :src="$$FormData.diyimg1" />
        </div>
        <div class="diy-img diy-img-2 ">
          <!-- <span>{{ $$FormData.diyimg1t }}</span> -->
          <img :src="$$FormData.diyimg2" />
        </div>
        <div class="diy-img">
          <!-- <span>{{ $$FormData.diyimg1t }}</span> -->
          <img :src="$$FormData.diyimg3" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssistSlicer2Preview',
  data() {
    return {
      show_swiper: true,
      imgList: [],
    };
  },
  computed: {
    swiperOptions() {
      const formData = this.$$FormData;
      console.log('this.$$FormData', this.$$FormData);
      return {
        loop: true,
        pagination: formData.show_pagination ? { el: '.swiper-pagination' } : false,
        autoplay: formData.autoplay
          ? {
              disableOnInteraction: false,
            }
          : false,
        direction: formData.direction,
        effect: formData.effect,
        // 生效时间, 时间
        startTime: formData.startTime,
        // 过期时间, 时间
        endTime: formData.endTime,
      };
    },
  },
  watch: {
    swiperOptions: {
      deep: true,
      handler: 'updateSwiper',
      immediate:true
    },
    '$$FormData.imageList': {
      deep: true,
      handler: 'updateSwiper',
    },
  },
  methods: {
    updateSwiper() {
      this.show_swiper = false;
      // this.$nextTick(() => {
      //   this.show_swiper = true
      // })
      console.log('this.$$FormData.imageList', this.$$FormData.imageList);
      this.$$FormData.imageList.forEach(item => {
        if (item.startTime && item.endTime) {
          let timer = new Date().getTime();
          let startTime = new Date(item.startTime).getTime();
          let endTime = new Date(item.endTime).getTime();
          console.log('timer', timer);
          console.log('startTime', startTime);
          console.log('endTime', endTime);
          if (timer > startTime && timer < endTime) {
            item.showImg = true;
          } else {
            item.showImg = false;
          }
        }
      });
      this.imgList = this.$$FormData.imageList.filter(item => {
        return item.showImg;
      });
      console.log('$$FormData.imageList2', this.$$FormData.imageList);
      this.$nextTick(() => {
        this.show_swiper = this.$$FormData.imageList.some(item => {
          return item.showImg;
        });
      });
    },
  },
  mounted() {
    var bodyArray = document.getElementsByTagName('body');
    var body = bodyArray[0];
    //修改body元素的背景颜色属性
    body.style.background = this.$$FormData.pagination_background;

    console.log(this.$store.getters.site);
    this.$store.getters.site.logo = this.$$FormData.pagination_logo;
    let zyzlogo1 = document.getElementsByClassName('zyzlogo1')[0];
    zyzlogo1.style.display = 'none';
    let zyzlogo2 = document.getElementsByClassName('zyzlogo2')[0];
    zyzlogo2.style.display = 'block';
  },
};
</script>

<style lang="scss" scoped>
.assist-slicer2 {
  overflow: hidden;
  &__hr {
    width: 100%;
    margin: 10px 0;
    border: 0;
  }
}
.swiper-pc2 {
  width: 764px;
  // background: black;
  float: left;
  &__swiper {
  }
  &__swiper,
  &__item,
  &__image,
  .swiper-container {
    width: 100%;
    height: 100%;
    &.swiper-container-vertical /deep/ .swiper-pagination-bullet-active {
      width: 8px;
      height: 15px;
    }
    /deep/ {
      .swiper-pagination-bullet {
        transition: all ease 0.5s;
        border-radius: 4px;
        background-color: var(--dot-color) !important;
      }
      .swiper-pagination-bullet-active {
        width: 15px;
        background-color: var(--dot-color-active) !important;
      }
    }
  }
  &__image {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
  &__empty {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #7d7d80;
    font-size: 20px;
  }
}
.zyz-diytp-1 {
  float: left;
  width: 193px;
  height: 450px;
  // background: yellow;
  margin-right: 6px;
  margin-left: 6px;
  .diy-img {
    height: 145px;
    width: 193px;
    background-color: #fff;
    img {
      width: 193px;
      height: 145px;
    }
  }
  .diy-img-2 {
    margin: 7px 0px;
  }
}

.zyz-diytp-1-1 {
  float: left;
  width: 430px;
  height: 450px;
  // background: yellow;
  margin-right: 6px;
  margin-left: 6px;
  .diy-img {
    height: 145px;
    width: 440px;
    background-color: #fff;
    img {
      width: 440px;
      height: 145px;
    }
  }
  .diy-img-2 {
    margin: 7px 0px;
  }
}
.zyz-diytp-2 {
  float: left;
  width: 240px;
  height: 450px;
  background: yellowgreen;

  .diy-t {
    height: 150px;
    width: 240px;
    background-color: #fff;
    img {
      width: 193px;
      height: 162px;
    }
    .zyzt1 {
      padding: 6px 12px;
      width: 49px;
      height: 13px;
      font-size: 12px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 900;
      text-align: left;
      color: #333333;
      line-height: 32px;
    }
    .zyzt2 {
      img {
        width: 65px;
        height: 29px;
        margin: 17px 7px;
        float: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Decors/AssistSlicer2/AssistSlicer2Preview.vue